import React from 'react';

import { useSelectedQuantityContext } from '../../../context/TreatmentSelectorContext';
import formatQuantityLabel from '../../../../../components/Treatment/helpers/formatQuantityLabel';
import formatPrice from '../../../../../helpers/formatPrice';

import Typography from '../../../../../components/_ui/_blocks/Typography/Typography';

interface Props {
    selectedQuantity: NonNullable<ReturnType<typeof useSelectedQuantityContext>>;
}

const QuantityRow = ({ selectedQuantity }: Props) =>(
    <li>
        <Typography as="div" size="090">
            {formatQuantityLabel(selectedQuantity)}
        </Typography>
        <Typography as="div" size="300" color="price" weight="700" lineHeight="300">
            {formatPrice(selectedQuantity.price)}
        </Typography>
    </li>
);

export default QuantityRow;
